module.exports = __webpack_public_path__ + "static/51gde-ff9c2485d5cd02c23df8224577582846.gif";